import { IMyTicket } from '../ticketshop/types';

/**
 * Whether the "Ticket als Chipkarte erhalten" entry is offered for a ticket.
 *
 * Trusts the BE-provided `eligibilityForChipcard` flag (detail endpoint). The
 * backend owns the decision — which operator, billing mode and ticket class
 * qualify — so the frontend no longer re-derives it from `operatorName` /
 * `billingMode` (MC-11409). Absent flag (e.g. the list model) is not eligible.
 */
export const isChipcardEligible = (ticket: IMyTicket): boolean =>
	ticket.eligibilityForChipcard === true;
